import type { CSSProperties } from "react"

export const PLACEHOLDERS = {
  lessonTitle: "Title",
  cardTitle: "Title",
  // We need a non-empty string or else blank cards collapse.
  emptyCard: " ",
  emptyBlock: "Type or use + to add files & more",
  commentContent: "Add a comment",
} as const

/**
 * Names the prompt an element's empty content slot paints. Set on the host, read by that
 * extension's `::before` rule as `content: var(--placeholder)`; a slot with no host naming one
 * paints nothing, since an unresolvable `var()` leaves `content` at its initial value.
 *
 * JSON.stringify because `content` takes a CSS *string*, and CSS strings quote and escape the
 * same way JSON's do.
 */
export const placeholderStyle = (text: string): CSSProperties =>
  ({ "--placeholder": JSON.stringify(text) }) as CSSProperties
